import { LoginForm } from "../components/Auth/LoginForm";

export function LoginPage() {
  return (
    <div className="flex min-h-full items-center justify-center p-4">
      <LoginForm />
    </div>
  );
}
